import { Yup } from '@src/shared/validation';
import type { TFunction } from 'i18next';

type UserReference = { id: number | string } | null | undefined;

export type UserHrIssue = 'self' | 'manager';

// Mirrors the server rule: HR cannot be the user and cannot be the manager.
// A user may still be their own manager.
export function getUserHrIssue(
  hr: UserReference,
  manager: UserReference,
  userId?: number | string | null,
): UserHrIssue | null {
  if (!hr) {
    return null;
  }
  const hrId = String(hr.id);
  if (userId !== null && userId !== undefined && hrId === String(userId)) {
    return 'self';
  }
  if (manager && hrId === String(manager.id)) {
    return 'manager';
  }
  return null;
}

// Schema of the `hr` form field; reads the manager from the sibling
// `manager` field. `userId` is absent while the user is being created.
export function getUserHrSchema(t: TFunction, userId?: number | string | null) {
  return Yup.object()
    .nullable()
    .test(
      'hr-not-self',
      t('users.validation.hr_is_self', 'A user cannot be their own HR'),
      (value, context) =>
        getUserHrIssue(
          value as UserReference,
          context.parent.manager,
          userId,
        ) !== 'self',
    )
    .test(
      'hr-not-manager',
      t(
        'users.validation.hr_equals_manager',
        'Manager and HR cannot be identical',
      ),
      (value, context) =>
        getUserHrIssue(
          value as UserReference,
          context.parent.manager,
          userId,
        ) !== 'manager',
    );
}
